import { resources } from "@constants/hardcoded-strings";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { Dispatch } from "redux";

import { AxnAdminUser } from "@idw-types/data/axn-admin-user";
import { archiveAxnAdminUserRequest } from "@requests/axnadmin-core/archive-axn-admin-user";
import { AxnAdminUserAccountStateTypes } from "@enums/axn-admin-user-account-state-types";
import { replaceOrganizationUser } from "@redux/actions/organization-users-actions";

export const archiveOrganizationUserReduxRequest = (dispatch: Dispatch) => async (
    userId: string
): Promise<AxnAdminUser> => {
    const { data, error } = await archiveAxnAdminUserRequest(userId);
    if (data) {
        dispatch(replaceOrganizationUser(data.transferObject, AxnAdminUserAccountStateTypes.ARCHIVE));
        return data.transferObject;
    } else {
        if (error) {
            const errorResource = resources.requests.archiveOrganizationUser.error;

            logAndDisplayErrorModal(
                dispatch,
                error,
                errorResource.title,
                errorResource.message
            );
        }
    }

    return null;
};